import { API_URL } from './Config';
import { startLoading, endLoading, SnackBar, handleHTTPError, ShowLoadingSpinner, pageGifLoader } from './CommonActions';
import store from '../store';
import axios from 'axios';

export function storeDayTourDetails(list) {
    return {
        type: 'STORE_DAY_TOUR_DETAILS',
        list: list.data
    }
}

export function getDayTourDetails(peram) {
    return function (dispatch) {
        dispatch(pageGifLoader(true));
        dispatch(startLoading());
        fetch(API_URL + '/api/day_tour/details?permalink='+peram, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeDayTourDetails(json));
                    dispatch(pageGifLoader(false));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeRoundTourDetails(list) {
    return {
        type: 'STORE_ROUND_TOUR_DETAILS',
        list: list.data
    }
}

export function getRoundTourDetails(name) {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/round_tour/details?name='+name, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeRoundTourDetails(json));
                    dispatch(pageGifLoader(false));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }
}

export function storeMaldiveTourDetails(list) {
    return {
        type: 'STORE_MALDIVE_TOUR_DETAILS',
        list: list.data
    }
}

export function getMaldiveTourDetails(name) {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/maldives/packages/details?name=' + name, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(pageGifLoader(false));
                    dispatch(storeMaldiveTourDetails(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeMaldiveTourPrice(list) {
    return {
        type: 'STORE_MALDIVE_TOUR_PRICE',
        price: list.price
    }
}

export function getMaldivePrice(id, checkin = "", checkout = "") {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/maldives/get_price?tour_id=' + id + "&checkin_date=" + checkin + "&checkout_date=" + checkout, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeMaldiveTourPrice(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeMaldiveResortsDetails(list) {
    return {
        type: 'STORE_MALDIVE_RESORT_DETAILS',
        list: list.data
    }
}

export function getMaldiveResortsDetails(name) {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/maldives/resorts/details?name=' + name, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(pageGifLoader(false));
                    dispatch(storeMaldiveTourDetails(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeThingsToDoDetails(list) {
    return {
        type: 'STORE_THINGS_TO_DO_DETAILS',
        list: list.data
    }
}

export function getThingsToDoDetails(name) {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/ThingsToDo/details?name=' + name, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(pageGifLoader(false));
                    dispatch(storeThingsToDoDetails(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeBlogDetail(list) {
    return {
        type: 'STORE_BLOG_DETAILS',
        list: list.data
    }
}

export function getBlogDetail(name) {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/blog/details?name=' + name, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(pageGifLoader(false));
                    dispatch(storeBlogDetail(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeTransferDetails(list) {
    return {
        type: 'STORE_TRANSFER_DETAILS',
        list: list.data
    }
}

export function getTransferDetails() {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/transfers/details' , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(pageGifLoader(false));
                    dispatch(storeTransferDetails(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function storeRentCarDetails(list) {
    return {
        type: 'STORE_RENT_CAR_DETAILS',
        list: list.data
    }
}

export function getRentCarDetails(name) {
    return function (dispatch) {
        dispatch(startLoading());
        dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/rent_car/details?name=' + name , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(pageGifLoader(false));
                    dispatch(storeRentCarDetails(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}


export function storeTransferAmount(data) {
    return {
        type: 'STORE_TRANSFER_AMOUNT',
        result: data.result
    }
}

export function checkAmount(data) {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/transfer/check' , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body:JSON.stringify(data),
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeTransferAmount(json));
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}
